export const RESET_STATE_LEGALPERSON = 'RESET_STATE_LEGALPERSON'
export const LOADING_LEGALINFOBASIC = 'LOADING_LEGALINFOBASIC'
export const GET_LEGALINFOBASIC = 'GET_LEGALINFOBASIC'
export const GET_ERROR_LEGALINFOBASIC = 'GET_ERROR_LEGALINFOBASIC'
export const RESET_SUCCESS_LEGALPERSON = 'RESET_SUCCESS_LEGALPERSON'
export const GET_ACCIONISTA = 'GET_ACCIONISTA'
export const LOADING_ACCIONISTA = 'LOADING_ACCIONISTA'
export const GET_ERROR_ACCIONISTA = 'GET_ERROR_ACCIONISTA'
export const LOADING_ADMINISTRADOR = 'LOADING_ADMINISTRADOR'
export const GET_ADMINISTRADOR = 'GET_ADMINISTRADOR'
export const GET_ERROR_ADMINISTRADOR = 'GET_ERROR_ADMINISTRADOR'
export const LOADING_EMPLEADOS = 'LOADING_EMPLEADOS'
export const GET_EMPLEADOS = 'GET_EMPLEADOS'
export const GET_ERROR_EMPLEADOS = 'GET_ERROR_EMPLEADOS'
export const LOADING_CONTRIB_IMPUESTOS = 'LOADING_CONTRIB_IMPUESTOS'
export const GET_CONTRIB_IMPUESTOS = 'GET_CONTRIB_IMPUESTOS'
export const GET_ERROR_CONTRIB_IMPUESTOS = 'GET_ERROR_CONTRIB_IMPUESTOS'
export const GET_ACCIONISTA_SUPERCIAS = 'GET_ACCIONISTA_SUPERCIAS'
export const LOADING_ACCIONISTA_SUPERCIAS = 'LOADING_ACCIONISTA_SUPERCIAS'
export const GET_ERROR_ACCIONISTA_SUPERCIAS = 'GET_ERROR_ACCIONISTA_SUPERCIAS'
export const GET_ADMINISTRADORES_SUPERCIAS = 'GET_ADMINISTRADORES_SUPERCIAS'
export const LOADING_ADMINISTRADORES_SUPERCIAS = 'LOADING_ADMINISTRADORES_SUPERCIAS'
export const GET_ERROR_ADMINISTRADORES_SUPERCIAS = 'GET_ERROR_ADMINISTRADORES_SUPERCIAS'
export const GET_DEUDAS_FIRMES = 'GET_DEUDAS_FIRMES'
export const LOADING_DEUDAS_FIRMES = 'LOADING_DEUDAS_FIRMES'
export const GET_ERROR_DEUDAS_FIRMES = 'GET_ERROR_DEUDAS_FIRMES'

